import { DESIGN_PALETTE } from "../PlayerCore/palette.js"

export { DESIGN_PALETTE }

const HEX_COLOR = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i

// Pro's Website Builder "Player template" picker — same 4 PodcastThemeEnum cases
// PodcastController::colors() resolves real colors for server-side, so a single ?theme=creator
// (etc.) fully determines the look with no colors[...] query params needed at all. Deliberately
// NOT extended to dark/light/springcast/preview here — those already reach this function with
// real, distinct backend colors today and still get ignored on purpose; changing that is a
// separate, pre-existing gap this isn't meant to fix.
const COLOR_DRIVEN_THEMES = ["custom", "creator", "bold", "editorial", "minimal"]

export function themeVars(colors, themeName) {
    const vars = { ...DESIGN_PALETTE }

    if (!COLOR_DRIVEN_THEMES.includes(themeName) || !colors) {
        return vars
    }

    if (HEX_COLOR.test(colors.player_main_accent ?? "")) {
        vars["--vp-accent"] = colors.player_main_accent
    }

    if (HEX_COLOR.test(colors.player_background ?? "")) {
        // --vp-panel only backs the occasional floating popovers (chapters/quality/transcript —
        // see PlayerShell.vue's .vp-panel usage); --vp-ink is the player's actual dominant,
        // always-visible surface (.vp-root's own background, the <video> letterbox color, and
        // the solid backdrop shown in audio-only mode) — both need the override, or picking a
        // custom background would only ever show up in rarely-opened menus.
        vars["--vp-panel"] = colors.player_background
        vars["--vp-ink"] = colors.player_background
    }

    return vars
}
